<template>
  <div :class="`searchbar-wrapper ${className}`">
    <!-- <el-radio-group v-model="listMode" class="change-modal" size="mini" @change="listModel">
      <el-radio-button label="table"><i class="el-icon-s-grid"></i></el-radio-button>
      <el-radio-button label="list"><i class="el-icon-notebook-2"></i></el-radio-button>
    </el-radio-group> -->
    <el-button v-if="tableType==='阶段模式'" class="change-modal" size="mini" type="primary" plain @click="modifyTableType('列表模式')">列表模式</el-button>
    <el-button v-else class="change-modal" size="mini" type="primary" plain @click="modifyTableType('阶段模式')">阶段模式</el-button>
    <div class="flex-2 pr10">
      <div class="searchbar-item">
        <span class="label" style="width:92px">客户公司：</span>
        <el-autocomplete
          v-model="query.客户公司"
          class="flex-grow1"
          size="mini"
          :fetch-suggestions="searchCompany"
          placeholder="请输入公司名称（多个公司用空格区分）"
        >
          <template slot-scope="{ item }">
            <span v-if="item.highlight" class="keyword-item" v-html="item.highlight"></span>
            <span v-else> <i class="el-icon-time"></i> &nbsp;{{ item.value }} </span>
          </template>
          <div
            slot="suffix"
            style="cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;height:28px"
            @click="$refs.SelectCompany.open()"
          >
            <i slot="suffix" class="el-icon-question" style="margin-right:5px" />公司库
          </div>
        </el-autocomplete>
      </div>
      <div v-if="!isFolded" class="searchbar-item">
        <span class="label" style="width:92px">岗位名称&职能：</span>
        <div class="flex-grow1">
          <PosCate
            ref="PosCate"
            :ignore="['关键词', '个性标签']"
            :show-category-detail="false"
            @confirm="posCateComfirm"
          ></PosCate>
          <div v-if="query['岗位名称和职能模块'].length > 0" class="radish-search-item" style="padding-bottom:4px">
            <div class="radish-poscate-conditions">
              <el-tag
                v-for="(tag, k) in query['岗位名称和职能模块']"
                :key="k"
                size="small"
                effect="plain"
                style="margin-right:2px;margin-bottom:4px;"
                closable
                @close="removePosCate(tag, k)"
                >{{ tag.label }}</el-tag
              >
            </div>
          </div>
        </div>
        <!-- <input v-model="query.岗位名称和职能模块" type="text"> -->
      </div>
      <div v-if="!hideSearchMember && !isFolded" class="searchbar-item">
        <span class="label" style="width:92px">参与成员：</span>
        <div class="flex-grow1">
          <SearchProjectMember res="SearchProjectMember" @confirm="posMemberComfirm"></SearchProjectMember>
          <div v-if="query['参与成员'].length > 0" class="radish-search-item" style="padding-bottom:4px">
            <div class="radish-poscate-conditions">
              <el-tag
                v-for="(tag, k) in query['参与成员']"
                :key="k"
                size="small"
                effect="plain"
                style="margin-right:2px;margin-bottom:4px;"
                closable
                @close="removePosMember(tag, k)"
                >{{ tag.label }}</el-tag
              >
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isFolded" class="searchbar-item">
        <span class="label" style="width:92px">项目时间：</span>
        <div class="flex-grow1 flex">
          <el-date-picker v-model="date1" size="mini" type="date" style="margin-right: 6px;" placeholder="选择日期">
          </el-date-picker>
          <el-date-picker v-model="date2" size="mini" type="date" placeholder="选择日期"> </el-date-picker>
        </div>
      </div>
      <div v-if="!isFolded" class="searchbar-item">
        <span class="label" style="width:92px">项目编号：</span>
        <div class="flex-grow1"><el-input v-model="query.编号" size="mini" placeholder="请输入项目编号" /></div>
      </div>
    </div>
    <div class="flex-3 pr10">
      <div v-if="!isFolded" class="searchbar-item">
        <span class="label" style="width:60px">地域：</span>
        <div class="value-box">
          <el-tag
            v-for="(city, k) in query.地域"
            :key="k + 'ct1'"
            class="mr5"
            effect="dark"
            size="small"
            closable
            @close="toogleTag('地域', city)"
            >{{ city }}</el-tag
          >
          <template v-for="(city, k) in opts.地域">
            <div
              v-show="!query.地域.includes(city)"
              :key="k + 'c1'"
              class="radish-search-tag"
              @click="toogleTag('地域', city)"
            >
              {{ city }}
            </div>
          </template>
          <el-input
            v-model="currentCity"
            class="radish-search-city-input"
            size="mini"
            placeholder="请输入其他城市并回车"
            @change="addCity('currentCity', '地域')"
          />
        </div>
      </div>
      <div v-if="!isFolded" class="searchbar-item">
        <span class="label" style="width:60px">项目状态：</span>
        <div
          v-for="(v, k) in opts.项目状态"
          :key="k"
          class="radish-search-tag"
          :class="{ 'radish-search-tag-active': query.项目状态.includes(v) }"
          @click="toogleTag('项目状态', v)"
        >
          {{ v }}
        </div>
      </div>
      <div class="searchbar-item">
        <span class="label" style="width:60px">项目阶段：</span>
        <div
          v-for="(v, k) in opts.项目阶段"
          :key="k"
          class="radish-search-tag"
          :class="{ 'radish-search-tag-active': query.项目阶段.includes(v) }"
          @click="toogleTag('项目阶段', v)"
        >
          {{ v }}
        </div>
      </div>
      <div v-if="!isFolded" class="searchbar-item">
        <span class="label" style="width:60px">优先级：</span>
        <el-rate v-model="query.优先级"></el-rate>
        <!-- <input v-model="query.客户公司" type="text"> -->
      </div>
      <div v-if="!isFolded" class="searchbar-item">
        <span class="label" style="width:60px">发布圆手：</span>
        <el-checkbox v-model="query.发布圆手">是</el-checkbox>
      </div>
    </div>
    <div class="flex-2">
      <div v-if="!isFolded" class="searchbar-item">
        <span class="label" style="width:60px">是否独家：</span>
        <div
          class="radish-search-tag"
          :class="{ 'radish-search-tag-active': !query.独家 }"
          @click="setTag('独家', null)"
        >
          不限
        </div>
        <div
          v-for="(v, k) in opts.独家"
          :key="k"
          class="radish-search-tag"
          :class="{ 'radish-search-tag-active': query.独家 === v }"
          @click="setTag('独家', v)"
        >
          {{ v }}
        </div>
      </div>
      <div v-if="!isFolded" class="searchbar-item">
        <span class="label" style="width:60px">职级：</span>
        <el-select v-model="query['职级']" size="mini" multiple placeholder="职级" class="radish-search-select">
          <el-option v-for="opt in opts.职级" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
        </el-select>
        <el-button size="mini" type="text" style="margin-left:10px" @click="setTag('职级', ['1', '2'])"
          >高端岗位</el-button
        >
      </div>
      <div v-if="!isFolded" class="searchbar-item">
        <span class="label" style="width:60px">行业：</span>
        <el-select
          v-model="query.目标行业"
          size="mini"
          multiple
          placeholder="行业（不限，可多选）"
          class="radish-search-select"
          filterable
        >
          <el-option v-for="(v, k) in opts.目标行业" :key="k" :label="v" :value="v"></el-option>
        </el-select>
      </div>
      <!-- <div v-if="!isFolded" class="searchbar-item">
        <span class="label" style="width:60px">排序：</span>
        <div
          v-for="v in ['优先级', '创建时间']"
          :key="v"
          class="radish-search-tag"
          :class="{ 'radish-search-tag-active': sortType === v }"
          @click="sortType = v"
        >
          {{ v }}
        </div>
      </div> -->
      <div class="searchbar-item">
        <el-button size="mini" type="primary" style="margin-left:10px" @click="toSearch">搜索</el-button>
        <el-button size="mini" style="margin-left:10px" @click="clearSearch">清空</el-button>
        <el-button size="mini" style="margin-left:10px" @click="isFolded = !isFolded">{{
          isFolded ? '展开' : '收起'
        }}</el-button>
      </div>
    </div>
    <!-- component -->
    <SelectCompany ref="SelectCompany" @confirm="addCompany"></SelectCompany>
  </div>
</template>

<script>
import SelectCompany from '../../../company/src/hunting/selectCompany'
import SearchProjectMember from './SearchProjectMember'

import BaseSearchBarItem from './BaseSearchBarItem.vue'
import { locations } from '../constant/type'
import PosCate from '../../../radish/src/radishlist/copy-pos-cate.vue'

const dateFormat = require('dateformat')

export default {
  components: { PosCate, SelectCompany, SearchProjectMember },
  props: {
    onSearch: { type: Function, default: () => {} },
    onCollapse: { type: Function, default: () => {} },
    className: { type: String, default: '' },
    hideSearchMember: { type: Boolean, default: false },
  },
  data() {
    return {
      query: {
        客户公司: '',
        地域: [],
        独家: null, // 独家岗位: true, 非独家岗位: false, 不限则不传
        编号: '',
        岗位名称和职能模块: [
          // 参考人才搜索中的职位和职能模块组件
          // { 职能模块: 'EQ-股票投资'},
          // { 职能模块: 'EQ-股票投资', 擅长方向: '年金投资'},
          // { 部门: '人力资源' },
          // { 职位名称: '基金会计' }, // 此处对应`项目名称`，为了组件复用，后端处理字段
        ],
        项目状态: [],
        职级: [], // 高端职位
        参与成员: [],
        项目阶段: [],
        目标行业: [], // 搜索显示'行业'，传字段键值'目标行业'
        项目时间: [], // 起始/结束时间字符串或时间戳；如果没有截止时间则第二个数组不传
        优先级: 0, // 对应紧急程度,
        发布圆手: false, //是否在圆手是已上线状态
      },
      isFolded: false,
      date1: '',
      date2: '',
      currentCity: '',
      comHistory: [],
      companyRes: [],
      opts: {
        独家: ['独家岗位', '非独家岗位'],
        项目状态: ['进展中', '已成功', '已暂停', '已失败'],
        项目阶段: ['项目创建', '人才搜寻', '职位推荐', '面试阶段', 'offer谈判', '离职管理', '开票催款'],
        目标行业: app.industries ? app.industries.concat('空') : [],
        地域: ['北京', '上海', '广州', '深圳', '天津', '香港', '杭州'],
        职级: [
          { value: '1', label: '1.高管' },
          { value: '2', label: '2.部门总' },
          { value: '3', label: '3.部门副总/总助/团队长' },
          { value: '4', label: '4.部门核心骨干' },
          { value: '5', label: '5.新人三年以下' },
          { value: '空', label: '空' },
        ],
      },
      listMode: 'table',
      tableType: '阶段模式',
      // sortType: '优先级',
    }
  },
  methods: {
    modifyTableType(type){
      this.tableType = type
      this.$emit('tableTypeChange',type)
    },
    listModel() {
      this.$router.push('/projs')
    },
    toSearch() {
      const query = window._.cloneDeep(this.query)
      if (query.客户公司) query.客户公司 = query.客户公司.split(' ').filter(v => v)
      else delete query.客户公司
      if (query.独家) query.独家 = query.独家 === '独家岗位'
      else delete query.独家
      query.岗位名称和职能模块 = query.岗位名称和职能模块.map(q => {
        const obj = {}
        if (q.name == '细分职能' || q.name == '擅长方向') {
          // console.log(q.val)
          const arr = q.val.split('@@')
          obj.职能模块 = arr[0]
          obj[q.name] = arr[1]
        } else {
          obj[q.name] = q.val
        }
        return obj
      })
      if (query.项目阶段.includes('人才搜寻')) {
        const index = query.项目阶段.findIndex(v => v === '人才搜寻')
        query.项目阶段.splice(index, 1, '人才搜索')
      }
      const members = []
      const types = ['客户开发', '项目对接', '项目经理', '项目成员']
      query.参与成员.forEach(val => {
        if (val.type === '全部') {
          types.forEach(type => members.push({ [type]: val.value }))
        } else members.push({ [val.type]: val.value })
      })
      query.参与成员 = members

      if (this.date1 && this.date2) {
        const time1 = new Date(this.date1).getTime()
        const time2 = new Date(this.date2).getTime()
        if (time1 > time2) query.项目时间 = [time2, time1]
        else query.项目时间 = [time1, time2]
      } else if (this.date1 || this.date2) {
        query.项目时间 = [new Date(this.date1 || this.date2).getTime()]
      }
      Object.keys(query).forEach(field => {
        const value = query[field]
        if (Array.isArray(value) && value.length === 0) {
          delete query[field]
        } else if (!value) delete query[field]
      })
      // this.onSearch(query, this.sortType)
      this.onSearch(query)
      this.isFolded = true
    },
    clearSearch() {
      Object.keys(this.query).forEach(field => {
        const val = this.query[field]
        if (Array.isArray(val)) {
          this.$set(this.query, field, [])
        } else if (typeof val === 'number') {
          this.$set(this.query, field, 0)
        } else {
          this.$set(this.query, field, null)
        }
      })
    },
    addCompany(company) {
      if (!company || company.length === 0) return
      const arr = (this.query.客户公司 || '').split(' ')
      const setObj = new Set(arr.concat(company))
      this.query.客户公司 = [...setObj].join(' ')
    },
    async searchCompany(queryString, cb) {
      const keywords = (queryString || '').trim()
      if (!keywords) {
        if (this.comHistory.length === 0) {
          const res = await this.getCompany()
          cb(res)
        } else {
          cb(this.comHistory)
        }
      } else if (keywords !== queryString || this.keywordsLoading) {
        cb(this.companyRes)
      } else {
        this.companyRes = await this.createFilter(keywords, ['公司'])
        cb(this.companyRes)
      }
    },
    async createFilter(keywords, fields) {
      this.keywordsLoading = true
      const arr = keywords.split(/\s+/)
      const keyword = arr.pop()
      const highlight = arr.join(' ')
      const q = { keyword }
      if (fields) q.fields = fields
      const res = await app.service('radish').listKeywords(q)
      this.keywordsLoading = false
      if (res.status === 'success') {
        return res.data.map(dt => {
          const item = {
            value: highlight ? `${highlight} ${dt.keyword}` : dt.keyword,
            highlight: `<span>${highlight}</span>${highlight ? ' ' : ''}${dt.keyword.replace(
              keyword,
              `<span>${keyword}</span>`,
            )}`,
          }
          return item
        })
      }
      return []
    },
    async getCompany() {
      const ind = this.query['目标行业'] && this.query['目标行业'].length > 0 ? this.query['目标行业'][0] : '公募基金'
      const res = await app.service('company').getCompanySimpleList({
        query: { 行业: ind },
        fields: { 公司名称: 1, 简称: 1, 排名: 1 },
        sort: { 排名: 1 },
        limit: 10,
      })
      if (res.status === 'success') {
        return res.data.filter(h => h.简称).map(h => ({ value: h.简称 }))
      }
      return []
    },
    addCity(dataName, fieldName) {
      if (this.query[fieldName] && this.query[fieldName].length > 8) {
        return this.$message('最多可以添加8个城市')
      }
      const city = this[dataName]
      if (!this.query[fieldName].includes(city)) this.query[fieldName].push(city)
      this[dataName] = ''
    },
    setTag(name, val) {
      this.$set(this.query, name, val)
    },
    toogleTag(name, val, isAdd) {
      const arr = this.query[name] || []
      const index = arr.findIndex(v => v === val)
      if (index === -1) arr.push(val)
      else arr.splice(index, 1)
      this.$set(this.query, name, arr)
    },
    removePosCate(tag, k) {
      this.query['岗位名称和职能模块'].splice(k, 1)
    },
    removePosMember(tag, k) {
      this.query['参与成员'].splice(k, 1)
    },
    posCateComfirm(checkedData) {
      const array = []
      checkedData.map(val => {
        this.query['岗位名称和职能模块'].every(thisval => thisval.label !== val.label) && array.push(val)
      })
      this.query['岗位名称和职能模块'] = this.query['岗位名称和职能模块'].concat(array)
    },
    posMemberComfirm(checkedData) {
      checkedData.forEach(val => {
        if (val.type === '全部') {
          this.query['参与成员'] = this.query['参与成员'].filter(v => v.value !== val.value)
          this.query['参与成员'].push(val)
        } else {
          this.query['参与成员'] = this.query['参与成员'].filter(v => v.value !== val.value || v.type !== '全部')
          this.query['参与成员'].every(thisval => thisval.label !== val.label) && this.query['参与成员'].push(val)
        }
      })
    },
  },
}
</script>
<style>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: auto;
}
.searchbar-item .el-icon-question {
  color: #409eff;
  cursor: pointer;
}
.radish-poscate-conditions > .el-tag {
  margin-bottom: 2px;
  margin-right: 2px;
  font-size: 14px;
}
</style>
<style scoped>
.pr10 {
  padding-right: 10px;
}
.searchbar-wrapper {
  margin: 0 0 5px 0;
  padding: 8px 20px;
  border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
  display: flex;
  position: relative;
}
.change-modal {
  position: absolute;
  top: 10px;
  right: 15px;
}
.flex-1 {
  flex: 1;
}
.flex-2 {
  flex: 2;
}
.flex-3 {
  flex: 3;
}
.flex-grow1 {
  flex-grow: 1;
}
.flex {
  display: flex;
}
.searchbar-item {
  display: flex;
  align-items: center;
  padding: 4px 0;
}
.searchbar-item .label {
  word-break: keep-all;
}
.value-box {
  display: flex;
  flex-wrap: wrap;
}
.radish-search-tag {
  display: inline-block;
  padding: 0 7px;
  margin: 2px 5px 2px 0;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  color: #a19fa5;
  word-break: keep-all;
}
.radish-search-tag.radish-search-tag-active {
  background-color: #409eff;
  color: #fff;
}
.radish-search-city-input {
  width: 150px;
}
</style>
